import { cn } from '@/lib/cn'

/** Общий вид полей ввода (Input, Select): 44 px на телефоне, 40 px на десктопе. */
export const controlClass = cn(
  'w-full min-w-0 rounded-lg border border-border bg-surface px-3 text-base text-fg lg:text-sm',
  'min-h-11 lg:min-h-10 placeholder:text-muted',
  'focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/25',
  'disabled:opacity-60 aria-[invalid=true]:border-danger',
)
